import { useMemo, useState, type FormEvent } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { api } from '../api/client'
import { PageShell } from '../components/BrandChrome'
import { Alert, Button, Card, Input, Label, Subtitle, Title } from '../components/ui'
import { errorMessage } from '../lib/format'

export function VerifyEmailPage() {
  const [params] = useSearchParams()
  const initial = useMemo(() => params.get('token') ?? '', [params])
  const [token, setToken] = useState(initial)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [ok, setOk] = useState(false)

  async function onSubmit(e: FormEvent) {
    e.preventDefault()
    setError(null)
    setBusy(true)
    try {
      await api.verifyEmail(token.trim())
      setOk(true)
    } catch (err) {
      setError(errorMessage(err))
    } finally {
      setBusy(false)
    }
  }

  return (
    <PageShell homeTo="/login">
      <Card className="mx-auto max-w-md">
        <Title>Verify email</Title>
        <Subtitle>Paste the verification token from your email if it did not open automatically.</Subtitle>
        {ok ? (
          <Alert tone="success">
            Email verified. You can <Link to="/login">sign in</Link> now.
          </Alert>
        ) : (
          <form className="space-y-4" onSubmit={onSubmit}>
            {error ? <Alert>{error}</Alert> : null}
            <div>
              <Label htmlFor="token">Verification token</Label>
              <Input
                id="token"
                name="token"
                required
                value={token}
                onChange={(ev) => setToken(ev.target.value)}
              />
            </div>
            <Button type="submit" disabled={busy || !token.trim()} className="w-full">
              {busy ? 'Verifying…' : 'Verify'}
            </Button>
          </form>
        )}
      </Card>
    </PageShell>
  )
}
